export interface ITriggerE2eTestResponse {
  triggerE2eTest: {
    success: boolean;
    testName: string;
    message: string;
  };
}

export const triggerE2eTestMutation = `
  mutation($testName: String!) {
    triggerE2eTest(testName: $testName) {
      success
      testName
      message
    }
  }
`;
